import { render, staticRenderFns } from "./ClipperUI.vue?vue&type=template&id=f2387ba2&scoped=true&"
import script from "./ClipperUI.vue?vue&type=script&lang=js&"
export * from "./ClipperUI.vue?vue&type=script&lang=js&"
import style0 from "./ClipperUI.vue?vue&type=style&index=0&id=f2387ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2387ba2",
  null
  
)

export default component.exports